import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";

const LoginPage: React.FC = () => {
  const { login, loading } = useAdminAuth();
  const [email, setEmail] = useState("admin@example.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      const redirectTo = (location.state as any)?.from?.pathname || "/";
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError("ログインに失敗しました。メール/パスワードを確認してください。");
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 bg-page md:grid-cols-2">
      <div className="hidden md:block" aria-hidden>
        <div className="relative h-full overflow-hidden" data-testid="login-art">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent"></div>
          <div className="absolute left-10 top-10 text-sm font-semibold text-primary">Admin Console</div>
          <div className="absolute bottom-10 left-10 max-w-sm text-ink opacity-80">
            <p className="text-xl font-semibold">読み取り中心から段階導入</p>
            <p className="text-sm text-muted">入金承認・公開切替は二段階確認で実行します。</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-10">
        <form
          className="w-full max-w-md rounded-2xl border border-surface-border bg-white p-8 shadow-card"
          onSubmit={handleSubmit}
        >
          <p className="text-xs uppercase tracking-[0.2em] text-muted">Blackadder</p>
          <h1 className="mt-2 text-2xl font-semibold text-ink">Admin Sign in</h1>
          <p className="text-sm text-muted">/admin/login を叩く。scope:admin + Cookie</p>

          <div className="mt-6 space-y-3">
            <label className="form-field">
              <span>メールアドレス</span>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label className="form-field">
              <span>パスワード</span>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
          </div>

          {error && <p className="mt-3 text-sm text-rose-600">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full rounded-xl bg-primary px-4 py-3 text-center text-sm font-semibold text-white transition hover:bg-primary-strong disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
